import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from "../ui/dialog";
import { ContactSalesForm } from "./ContactSalesForm";

export function ContactSalesDialog({
    open,
    onOpenChange,
    defaultReason = "enterprise",
    defaultSeats = "200+",
    defaultTimeline = "Within 30 days",
}) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent
                className="max-w-2xl max-h-[min(90vh,900px)] overflow-y-auto border-white/10 bg-obsidian-200 text-white sm:rounded-2xl"
                data-testid="contact-sales-dialog"
            >
                <DialogHeader>
                    <DialogTitle className="font-outfit text-xl text-white">
                        Contact sales
                    </DialogTitle>
                    <DialogDescription className="text-zinc-400 text-sm">
                        Tell us about your team — a sales engineer will reply
                        within one business day.
                    </DialogDescription>
                </DialogHeader>
                {open && (
                    <ContactSalesForm
                        className="relative mt-2"
                        showHeader={false}
                        defaultReason={defaultReason}
                        defaultSeats={defaultSeats}
                        defaultTimeline={defaultTimeline}
                        onSuccess={() => onOpenChange(false)}
                        formId="contact-sales-modal-form"
                    />
                )}
            </DialogContent>
        </Dialog>
    );
}
